import axios from 'axios';

import { API_BASE_URL } from './constants';

export const api = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
});

/**
 * Helper function to create standardized
 * error responses with fake 900 and 910 status.
 * @param {any} error
 * @returns {object} result
 */
export const createErrorResponse = error => {
  let result = null;
  if (error.response) result = error.response;
  else if (error.request) {
    result = error.request;
    result.status = 900;
  } else {
    result = error;
    result.status = 910;
  }
  return result;
};

/**
 * This higher order function takes in an array of handlers
 * for statuscodes ala `[[statusCode, (response) => {...}], ...]`.
 * It then creates a function which can be used to process an api response.
 * It calls the provided callback with the `response` as value,
 * if their `response.status` matches `statusCode` and then
 * returns the result of the callback.
 * @param {array} statusHandlers
 * @returns {[any|false]} result of the matching handler (or `false` no handler matched)
 */
export const handleResponse = statusHandlers => response => {
  const handler = statusHandlers.find(f => f[0] === response.status);
  if (!handler) {
    const defaultHandler = statusHandlers.find(f => f[0] === 'default');
    if (defaultHandler) {
      return defaultHandler[1](response);
    }
  } else {
    return handler[1](response);
  }
  return false;
};
